import {
  Box,
  Container,
  Card,
  Typography,
  Backdrop,
  Snackbar,
  Alert,
  CircularProgress,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Divider,
  Icon,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../components/dashboard_layout";
import axios from "../../axios";
import { useAuth } from "../../auth_provider";

function MyAccountPage() {
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [applicant, setApplicant] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/practitioners/profile.json`)
        .then((result) => {
          console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setApplicant(result.data.data.practitioner);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);
  return (
    <DashboardLayout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Box>
        <Container>
          <Box mb={3}>
            <Button
              startIcon={<Icon>chevron_left</Icon>}
              onClick={() => {
                window.history.back();
              }}
            >
              Back
            </Button>
          </Box>
          <Box>
            <Card>
              <CardContent>
                <Box mb={1} align="center">
                  <Icon>business</Icon>
                </Box>
                <Box mb={2}>
                  <Typography variant="h6" align="center">
                    {applicant.title}
                  </Typography>
                </Box>
                <Divider />
                <Table mt={1}>
                  <TableBody>
                    <TableRow>
                      <TableCell>Contact Person</TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" align="right">
                          {applicant.contact_person}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Email</TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" align="right">
                          {applicant.email_address}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Phone Number</TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" align="right">
                          {applicant.phone_number}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Address</TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" align="right">
                          {applicant.address}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>LGA</TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" align="right">
                          {applicant.lga}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>USERNAME</TableCell>
                      <TableCell>
                        <Typography variant="subtitle1" align="right">
                          {applicant.username}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </Box>
        </Container>
      </Box>
    </DashboardLayout>
  );
}

export default MyAccountPage;
